import { RG_TYPE } from "@project-rouge/rg-core";
import { Vector3toV3, applyTransform, getPivot } from "@project-rouge/rg-three";
function getCoreEntryPosition(core, pivot = [
	.5,
	0,
	0
]) {
	for (const wall of core.children.filter((c) => c.type === RG_TYPE.Wall)) {
		const door = wall.children.find((c) => c.type === RG_TYPE.Door && c.data.isEntrance);
		if (door) return Vector3toV3(applyTransform(getPivot(pivot, door), wall));
	}
	return Vector3toV3(getPivot([
		.5,
		0,
		0
	], core));
}
export { getCoreEntryPosition };

//# sourceMappingURL=index157.js.map